var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConseptimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1300,
    height: 527.843,
    viewBox: "0 0 1300 527.843",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "DSC_9519",
    d: "M-1723,577c-77.488-.894-154.976-21.788-232.464-22.682-88.108-1.017-176.216,27.966-264.324,26.95-95.449-1.1-197.212-27.268-286.345-25.3C-2585.84,557.72-2671,585-2745.3,565.2c-83.809-22.33-188.7-25.2-277.7-3.2V77c70,25,151.431,32.6,215.4,0,72.6-37,204.758-25.251,270.07,0,90.528,35,140.054,21.678,236.471,0C-2221,59-2138,61-2053.717,77c60.479,11.481,113.1,20,174.659,20,52.019,0,104.039-20,156.058-20Z",
    transform: "translate(3023 -53.452)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConseptimg);
export default __webpack_public_path__ + "static/media/conseptimg.1b61b70015d765196590f227b7efd35b.svg";
export { ForwardRef as ReactComponent };